import React from 'react'

import TopNavigationQuickSearch from "./model/quick-search";
import PopupMenuButton from "../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import QuickSearch_SettingsPopover from "../../../../app/search/quick/components/settings/popover"
import UI5ControlButton from "../../../app-controls/buttons/button/button"

// @ts-ignore
import onClickOutside from 'react-onclickoutside'


type Props = {
    onCloseModal?   : callback
    quickSearch     : TopNavigationQuickSearch
}

export default onClickOutside(class NavigationPanel_QuickSearchInput extends React.Component<Props>{

    constructor(props: Props) {
        super(props);

        this.props.quickSearch.componentInput = this
    }

    handleClickOutside = (e: MouseEvent) => {
        if (gd.utils.Dom.findNodeByClassName(e.target, this.props.quickSearch.outsideClickIgnoreClasses)) {
            return
        }

        this.props.quickSearch.isFocused = false
        this.forceUpdate()
    }

    onFocus = () => {
        this.props.quickSearch.isFocused = true
        this.forceUpdate()
    }

    onTogglePopover = (value: boolean) => {
        this.props.quickSearch.isSettingsPopoverShown = value
    }

    onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {



        const value = event.target.value ? event.target.value : '';

        // no trim !!!

        const query = value ? value.toLowerCase() : '';

        // console.log("input changed query=", query)

        this.setState({
            isFocused: query
        }, () => {
            this.props.quickSearch.setQuery(query)
        })
    }

    reRender = () => {
        this.forceUpdate()
    }

    render(): React.ReactNode {

        const className = Classes("search-input gd-input big", {
            'show-focus': this.props.quickSearch.searchEnabled || this.props.quickSearch.isFocused
        })

        const showSettings = this.props.quickSearch.searchEnabled || this.props.quickSearch.isFocused

        return (
            <div className="flex-row-center-center h-100-percent">
                <div className="search-area">
                    <input className    = {className}
                           type         = "input"
                           placeholder  = "Search"
                           value        = {this.props.quickSearch.query}
                           onFocus      = {this.onFocus}
                           onChange     = {this.onSearchChange}/>
                    <div className="i5-search"/>

                    {showSettings &&
                    <PopupMenuButton
                        offset          = "0 -6"
                        menuComponent   = {() => {
                            return <QuickSearch_SettingsPopover
                                onSettingsChanged={this.props.quickSearch.onSettingsChanged}/>
                        }}
                        btnComponent    = {(state: any) => {
                            const buttonClasses = Classes('search-settings-button', {
                                'hover-bg'  : state.showPopover
                            })
                            return <UI5ControlButton className  = {buttonClasses}
                                                     iconClass  = "i5-settings"/>
                        }}
                        onTogglePopover={this.onTogglePopover}
                    />}

                    {/*{this.props.quickSearch.searchEnabled &&*/}
                    {/*    <div className="i5-delete" onClick={this.props.quickSearch.cancel} />*/}
                    {/*}*/}
                </div>
            </div>
        )
    }
})
